import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

/**
 * GroupB:
 *  - Group is reponsible for displaying the following NODE_TYPE: [ STEP_NODE ]
 *  - Used in DesignViewOne
 */
export function GroupB(props) {
  const stepNode = (n) => {
    return React.cloneElement(props.stepNode, {
      ...props.stepNode.props,
      key: n.nodeId,
      nodeComponents: n.nodeComponents,
    });
  };

  const className = `design-view__groupB ${props.className}`;

  return <div className={className}>{props.groupNodes.map(stepNode)}</div>;
}

GroupB.propTypes = {
  /**
   * List of nodes to display in Group
   */
  groupNodes: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unique Id for Node
       */
      nodeId: PropTypes.number,
      /**
       * Type of Node
       */
      nodeType: PropTypes.oneOf(["STEP_NODE"]),
      /**
       * List of components to display on Node
       */
      nodeComponents: PropTypes.arrayOf(PropTypes.object),
    })
  ),
};

GroupB.defaultProps = {
  className: "",
  nodeComponents: [],
};
